import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Field, TagPicker } from "@hulahoop/ui";
import type { CulturalActivity } from "@/domain/investor";
import type { InvestorWizardFormData } from "@/domain/validation/investorSchemas";
import { useInvestorLabels } from "../hooks/useInvestorLabels";
import { WizardTextField } from "./WizardTextField";

export function CreateInvestorExtraStep() {
  const { t } = useTranslation();
  const form = useFormContext<InvestorWizardFormData>();
  const { interests } = useInvestorLabels();
  const chosen = form.watch("investmentInterests") ?? [];
  return (
    <>
      <div className="grid gap-(--card-gap) sm:grid-cols-2">
        <WizardTextField
          name="taxableIncomeBase"
          label="investors.attributes.tax_base"
          deps={["potentialInvestmentAmount"]}
        />
        <WizardTextField name="potentialInvestmentAmount" label="investors.attributes.potential" />
      </div>
      <Field label={t("investors.attributes.interests")}>
        <TagPicker
          label={t("investors.attributes.interests")}
          value={chosen.map(
            (interest) => interests.find((option) => option.value === interest)?.label ?? interest,
          )}
          options={interests.map((option) => option.label)}
          onChange={(labels) =>
            form.setValue(
              "investmentInterests",
              interests
                .filter((option) => labels.includes(option.label))
                .map((option) => option.value) as CulturalActivity[],
              { shouldValidate: true },
            )
          }
        />
      </Field>
    </>
  );
}
